// 模糊搜索人名接口
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
// 车型列表 模糊搜索车牌号接口
import { carModelList, FuzzySearch } from '@/api/domain/cars'

/**
 * getListFn: 页面列表接口（传入方法 “引用”）
 * searchData: 页面列表搜索参数
 * exportTemplate: 导出模板参数
 * otherFn: searchHandle所需要调用的其他方法（传入方法 “名字”）
 */
export default ({
  getListFn,
  searchData,
  exportTemplate,
  otherFn,
}) => {
  return {
    data() {
      return {
        exportParams: {}, // 导出参数
        searchData: Object.assign({}, searchData), // 搜索参数
        dateRange: [], // 时间区间
        tableData: [], // 表格数据
        dialogObj: { // 弹框相关参数，其他参数根据自身弹框扩展
          visible: false, // 显隐
          title: '', // 标题
          data: null, // 传入数据
        },
        paginationData: { // 分页
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizes: [5, 10, 20, 50],
        },
        oLoading: { // loading
          fuzzySearch: false, // 模糊搜索
          search: false, // 搜索
          state: false, // 状态
          fuzzy: false, //
          submit: false, // 提交
          export: false, // 导出
          exportByColumn: false, // 表格列上的导出
        },
        curstomerNameData: [], // 人名模糊搜索
        plateNoData: [], // 车牌号模糊搜索
        exportTemplate, // 导出模板
        formName: 'search', // 表单ref TODO: 先写死
      }
    },
    mounted() {
      this.searchHandle()
    },
    watch: {
      brandSeriesModel: {
        handler(val) {
          const { brandId, seriesId, modelId } = val
          this.searchData.brandId = brandId
          this.searchData.seriesId = seriesId
          this.searchData.modelId = modelId
        },
        deep: true,
      },
    },
    methods: {
      // 搜索事件
      searchHandle() {
        // 考虑带验证和不带验证的情况
        if (this.$refs[this.formName]) {
          this.$refs[this.formName].validate((valid) => {
            if (valid) {
              this.searchFn()
            }
          })
          return
        }
        this.searchFn()
      },
      searchFn() {
        otherFn && this[otherFn]()
        this.paginationData.pageNum = 1
        this.paginationChange({
          pagination: this.paginationData,
        })
      },
      // 切换页码
      paginationChange(payload) {
        const { pagination } = payload
        this.paginationData.pageSize = pagination.pageSize
        this.paginationData.pageNum = pagination.pageNum
        this.getList()
      },
      // 获取表格列表数据
      async getList() {
        this.oLoading.search = true
        try {
          const params = {
            ...this.getSearchParamrs(),
            pageSize: this.paginationData.pageSize,
            pageNum: this.paginationData.pageNum,
          }

          this.exportParams = Object.assign({}, params)

          const { code, data } = await getListFn.call(this, params)
          this.oLoading.search = false
          if (code === 1) {
            this.tableData = (data && data.items) || []
            this.paginationData.total = data.totalNum
          }
        } catch (error) {
          this.oLoading.search = false
        }
      },
      // 获取请求参数
      getSearchParamrs() {
        if (this.dateRange && this.dateRange.length > 0) {
          this.searchData.startDate = this.dateRange[0]
          this.searchData.endDate = this.dateRange[1]
        } else {
          delete this.searchData.startDate
          delete this.searchData.endDate
        }
        const params = {
          ...this.searchData,
          taskType: this.taskType,
        }
        return params
      },
      // 查看详情
      detailHandle(row) {
        this.$router.push({
          path: '/finance/receiptList',
          query: {
            id: row.receivableId,
          },
        })
      },
      // 清空然后搜索
      reset() {
        this.$refs[this.formName].resetFields()
        this.dateRange = []
        this.$refs.carBrandSeriesModelRef.reset()
        this.brandSeriesModel = {}
        this.searchData = Object.assign({}, searchData)
        this.searchHandle()
      },
      // 模糊搜索名字
      async loadNameData(query) {
        if (query.length < 1) return
        this.oLoading.fuzzySearch = true
        this.curstomerNameData = []
        const params = {
          customerName: query,
        }
        if (this.searchData.customerType) {
          params.customerType = this.searchData.customerType
        } else {
          params.mixedType = 'YES'
        }
        searchByCustomerNameSensitive(params).then(({ code, data = [] }) => {
          if (code === 1) {
            this.curstomerNameData = data
          }
        }).finally(() => {
          this.oLoading.fuzzySearch = false
        })
      },
      // 模糊搜索车牌号
      async loadPlateNoData(query) {
        if (query.length >= 4) {
          // 开启远程搜索
          this.oLoading.fuzzy = true
          try {
            const { code, data } = await FuzzySearch({
              plateNo: query,
              state: 2,
            })
            // 关闭远程搜索
            this.oLoading.fuzzy = false
            if (code === 1) {
              this.plateNoData = data
            }
          } catch (error) {
            this.oLoading.fuzzy = false
          }
        }
      },
      // 模糊搜索相关
      changeValue(e) {
        // if (str === 'customerManage') {
        if (!e) {
          this.curstomerNameData = []
          this.plateNoData = []
        }
        // }
      },
    },
  }
}
